import { Text } from "../units/Text";
import { useRef, useEffect } from "react";
import { Divider } from "../units/Divider";


export enum DateRangeEnum {
    Today,
    Week,
    Month,
    Quartal,
    Year,
    AllTime
}

export interface DateRangeInterface {
    start: string
    end: string
}

export const dateRangeValues = (dateRange: DateRangeEnum): DateRangeInterface | null => {
    const now = new Date();
    const end = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));

    const start = new Date(end);

    switch (dateRange) {
        case DateRangeEnum.Today:
            start.setUTCDate(start.getUTCDate() - 1);
            return {
                start: start.toISOString(),
                end: end.toISOString()
            }
        case DateRangeEnum.Week:
            start.setUTCDate(start.getUTCDate() - 7);
            return {
                start: start.toISOString(),
                end: end.toISOString()
            }
        case DateRangeEnum.Month:
            start.setUTCDate(start.getUTCDate() - 30);
            return {
                start: start.toISOString(),
                end: end.toISOString()
            }
        case DateRangeEnum.Quartal:
            start.setUTCDate(start.getUTCDate() - 90);
            return {
                start: start.toISOString(),
                end: end.toISOString()
            }
        case DateRangeEnum.Year:
            start.setUTCDate(start.getUTCDate() - 364);
            return {
                start: start.toISOString(),
                end: end.toISOString()
            }
        case DateRangeEnum.AllTime:
            return null

        default:
            return {
                start: start.toISOString(),
                end: end.toISOString()
            }
    }
}


export const selectedDateRangeRest = (value: DateRangeEnum):string => {
    switch (value) {
        case DateRangeEnum.Today:
            return "today"
        case DateRangeEnum.Week:
            return "week"
        case DateRangeEnum.Month:
            return "month"
        case DateRangeEnum.Quartal:
            return "quartal"
        default:
            throw "Must be one of enum"
    }
}


export const selectedDateRangeLabel = (value: DateRangeEnum):string => {
    switch (value) {
        case DateRangeEnum.Today:
            return "24ч"
        case DateRangeEnum.Week:
            return "Нед."
        case DateRangeEnum.Month:
            return "Мес."
        case DateRangeEnum.Quartal:
            return "Кв"
        default:
            throw "Must be one of enum"
    }
}


interface DateRangePickerProps {
    isOpen: boolean;
    dateRange: DateRangeEnum;
    setDateRangeOpen: (isOpen:boolean) => void;
    setDateRange: (dateRange: DateRangeEnum) => void;
}

export const DateRangePicker = ({isOpen, dateRange, setDateRangeOpen, setDateRange}: DateRangePickerProps) => {
    
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const isContentAreaClick = alertContentRef.current && event.target instanceof Node && alertContentRef.current.contains(event.target) ? true : false
            if (!isContentAreaClick) {
                setDateRangeOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const selectedDateRange = (dateRange: DateRangeEnum): string => {
        switch (dateRange) {
            case DateRangeEnum.Today:
                return "Сегодня"
            case DateRangeEnum.Week:
                return "Неделя"
            case DateRangeEnum.Month:
                return "Месяц"
            case DateRangeEnum.Quartal:
                return "Квартал"
            default:
                return "..."
        }
    }

    const alertContentRef = useRef<HTMLDivElement | null>(null);
    const degree = isOpen ? 0 : 180

    return (
        <div className="select-outter-wrapper" ref={alertContentRef} style={{height:'36px'}} onClick={() => setDateRangeOpen(!isOpen)}>
            <div className="select-wrapper">
                <div className="flex align-center space-between">
                    <div className="flex narrow-gap">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M15.5669 3.98636C16.0308 3.94857 16.5718 4.55546 16.5718 4.93486V15.103C16.6103 15.3687 16.0693 16.0893 15.6443 16.0893H4.31791C3.97023 16.0893 3.42891 15.4821 3.42891 15.1408V4.93521C3.3904 4.55581 4.00874 3.91077 4.3953 3.98672H5.74968V3.07602H4.24053C3.50593 3.07602 2.46252 4.10011 2.50104 4.82111V15.2549C2.50104 15.9378 3.42891 16.9622 4.20202 17H15.799C16.4562 17 17.4611 16.0134 17.5 15.2168V4.82111C17.5 4.10011 16.3792 3.00007 15.722 3.07602H14.2546V3.98672H15.5669V3.98636ZM7.60543 3.98636H12.3985V3.07602H7.60543V3.98636ZM6.67755 2C6.42093 2 6.21362 2.20348 6.21362 2.45535V4.12484C6.21362 4.37671 6.42093 4.58019 6.67755 4.58019C6.93418 4.58019 7.14149 4.37671 7.14149 4.12484V2.45535C7.14149 2.20348 6.93418 2 6.67755 2ZM13.3264 2C13.0694 2 12.8624 2.20348 12.8624 2.45535V4.12484C12.8624 4.37671 13.0694 4.58019 13.3264 4.58019C13.583 4.58019 13.7899 4.37671 13.7899 4.12484V2.45535C13.7899 2.20348 13.583 2 13.3264 2ZM6.98672 8.51653V9.88222H5.59491V8.51653H6.98672ZM7.75983 9.19938C7.75983 7.87148 7.60507 7.75774 6.29064 7.75774C5.71081 7.75774 5.01508 7.64399 4.8218 8.44058V9.95817C4.8218 10.2235 5.16985 10.5273 5.36312 10.5651C5.63342 10.641 6.17474 10.641 6.29064 10.641C7.60543 10.641 7.75983 10.4895 7.75983 9.19938ZM10.6979 8.51653V9.88222H9.30605V8.51653H10.6979ZM11.471 9.19938C11.471 7.87148 11.3162 7.75774 10.0018 7.75774C9.42195 7.75774 8.72622 7.64399 8.53294 8.44058V9.95817C8.53294 10.2235 8.88099 10.5273 9.07426 10.5651C9.34456 10.641 9.88588 10.641 10.0018 10.641C11.3162 10.641 11.471 10.4895 11.471 9.19938ZM14.4086 8.51653V9.88222H13.0172V8.51653H14.4086ZM15.1821 9.19938C15.1821 7.87148 15.0273 7.75774 13.7129 7.75774C13.1334 7.75774 12.4374 7.64399 12.2441 8.44058V9.95817C12.2441 10.2235 12.5921 10.5273 12.7854 10.5651C13.0561 10.641 13.597 10.641 13.7129 10.641C15.0273 10.641 15.1821 10.4895 15.1821 9.19938ZM6.98672 12.1586V13.5243H5.59491V12.1586H6.98672ZM7.75983 12.8418C7.75983 11.5136 7.60507 11.4002 6.29064 11.4002C5.71081 11.4002 5.01508 11.2864 4.8218 12.083V13.6006C4.8218 13.8663 5.16985 14.1697 5.36312 14.2079C5.63342 14.2838 6.17474 14.2838 6.29064 14.2838C7.60543 14.2835 7.75983 14.1316 7.75983 12.8418ZM10.6979 12.1586V13.5243H9.30605V12.1586H10.6979ZM11.471 12.8418C11.471 11.5136 11.3162 11.4002 10.0018 11.4002C9.42195 11.4002 8.72622 11.2864 8.53294 12.083V13.6006C8.53294 13.8663 8.88099 14.1697 9.07426 14.2079C9.34456 14.2838 9.88588 14.2838 10.0018 14.2838C11.3162 14.2835 11.471 14.1316 11.471 12.8418ZM14.4086 12.1586V13.5243H13.0172V12.1586H14.4086ZM15.1821 12.8418C15.1821 11.5136 15.0273 11.4002 13.7129 11.4002C13.1334 11.4002 12.4374 11.2864 12.2441 12.083V13.6006C12.2441 13.8663 12.5921 14.1697 12.7854 14.2079C13.0561 14.2838 13.597 14.2838 13.7129 14.2838C15.0273 14.2835 15.1821 14.1316 15.1821 12.8418Z" fill="black"/>
                        </svg>
                        <Text color='orange' className='bold'>{selectedDateRange(dateRange)}</Text>
                    </div>

                    <svg className='select-arrow' width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{rotate:`${degree}deg`}}>
                        <path d="M10.9652 7.5498L12.6781 5.93115L6.68282 0.265882L0.68753 5.93115L2.40047 7.5498L6.68282 3.50318L10.9652 7.5498Z" fill="black"/>
                    </svg>
                </div>
                {isOpen && (
                    <>
                    { Divider() }
                    <div className="">
                        <div className="option-row" onClick={(e) => {setDateRange(DateRangeEnum.Today); setDateRangeOpen(false)}}>
                            <Text color='secondary' className={ dateRange === DateRangeEnum.Today ? 'underline' : '' }>Сегодня</Text>
                        </div>
                        <div className="option-row" onClick={(e) => {setDateRange(DateRangeEnum.Week); setDateRangeOpen(false)}}>
                            <Text color='secondary' className={ dateRange === DateRangeEnum.Week ? 'underline' : '' }>Неделя</Text>
                        </div>
                        <div className="option-row" onClick={(e) => {setDateRange(DateRangeEnum.Month); setDateRangeOpen(false)}}>
                            <Text color='secondary' className={ dateRange === DateRangeEnum.Month ? 'underline' : '' }>Месяц</Text>
                        </div>
                        <div className="option-row" onClick={(e) => {setDateRange(DateRangeEnum.Quartal); setDateRangeOpen(false)}}>
                            <Text color='secondary' className={ dateRange === DateRangeEnum.Quartal ? 'underline' : '' }>Квартал</Text>
                        </div>
                    </div>
                    </>
                )}
                
            </div>
        </div>
    )
}